import { DATE_FORMATS } from '../../../constants';
import { DateTimeDisplayMode } from './DateTimeDisplayMode';

export const FORMAT_MAP: Record<DateTimeDisplayMode, string> = {
  [DateTimeDisplayMode.Countdown]: DATE_FORMATS.countdown,
  [DateTimeDisplayMode.Date]: DATE_FORMATS.standard,
  [DateTimeDisplayMode.DateKey]: DATE_FORMATS.keys,
  [DateTimeDisplayMode.DateTime]: DATE_FORMATS.standardWithTime,
  [DateTimeDisplayMode.DateTimeAmPm]: DATE_FORMATS.standardWithTimeTwelveHour,
  [DateTimeDisplayMode.DateTimeWithSeconds]:
    DATE_FORMATS.standardWithTimeAndSeconds,
  [DateTimeDisplayMode.DayMonth]: DATE_FORMATS.dayMonth,
  [DateTimeDisplayMode.FilenameStamp]: DATE_FORMATS.filenameStamp,
  [DateTimeDisplayMode.Rfc3339]: DATE_FORMATS.rfc3339,
  [DateTimeDisplayMode.UnixSeconds]: DATE_FORMATS.unixSeconds,
};
